.dateToday {
  color: var(--green-700);
}

.dateOverdue {
  color: var(--primary-main);
}

.dateFuture {
  color: var(--deep-purple-500);
}

.dateLabel {
  margin-right: 4px;
}
